import { render } from "./PictureCropper2.vue?vue&type=template&id=d387c738&scoped=true"
import script from "./PictureCropper2.vue?vue&type=script&lang=js"
export * from "./PictureCropper2.vue?vue&type=script&lang=js"

import "./PictureCropper2.vue?vue&type=style&index=0&id=d387c738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d387c738"]])

export default __exports__